import { render, staticRenderFns } from "./tiers.vue?vue&type=template&id=f24d9d8a"
import script from "./tiers.vue?vue&type=script&lang=js"
export * from "./tiers.vue?vue&type=script&lang=js"
import style0 from "./tiers.vue?vue&type=style&index=0&id=f24d9d8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports